<template lang="pug">
#section1
  #Intro
    .container-fluid.header.pt-3
      Navbar
      .container.main-title.mt-5
        .row.justify-content-center
          .col-10.text-center
            img.title-logo(src="/assets/mvdf.svg")
        .row.justify-content-center.mt-3
          .col-10.text-center
            img.title-img.pb-3(src="/assets/header-title.png")
    .container.introduction.pt-5
      .row.justify-content-center
        .col-11
          p El Memorial Disperso es un proyecto en realidad mixta que busca acercar el acceso al derecho a la memoria a familias mexicanas que han sufrido violaciones a sus derechos humanos, así como a las organizaciones que los acompañan.
          p Actualmente, las posibilidades de que mexicanos que han sufrido violencia puedan crear memoriales está limitado por el acceso a recursos económicos, políticos y mediáticos.&nbsp;
            span.bold El Memorial Disperso&nbsp;
            span busca aportar a la solución de este problema, aprovechando nuevas formas de fabricación y tecnologías emergentes para crear una plataforma de autogestión de memoriales que a la vez alimente una base de datos que permita compartir nuestra memoria.
          p Esta primera aproximación del&nbsp;
            span.bold Memorial Disperso&nbsp;
            span Memorial Disperso se ubica en el estado de Guerrero, enfocado a víctimas de desaparición forzada durante la Contrainsurgencia de la década de los sesentas y setentas. Conoce dónde están y a quién conmemoran.
          //- p Esta primera fase de tres instalará veinte prototipos del
          //-   span.bold Memorial Disperso
          //-   span en el estado de Guerrero, enfocado a víctimas de desaparición forzada durante la Contrainsurgencia de la década de los sesentas y setentas. Conoce dónde están, a quién conmemoran y cómo puedes solicitar tu participación en las siguientes fases.
      .row.justify-content-center
        p.uppercase.explore Explora
      .row.justify-content-center
        a.btn.btn-link(href="#section2", role="button")
          img.down(src="/assets/down.svg")
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  name: "introduction",
  components: {
    Navbar,
  },
};
</script>

<style lang="scss">
#Intro {
  .header {
    background-image: url("/assets/Header_MemorialDisperso_Web.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-blend-mode: soft-light;
    background-position: bottom;
  }
  .main-title {
    padding: 1.5rem 2.5rem;
  }
  .title-logo {
    max-height: 14vh;
    height: 13vh;
    max-width: 100%;
    object-fit: contain;
  }
  .title-img {
    max-height: 12vh;
    height: auto;
    max-width: 100%;
  }
  .introduction {
    font-size: 1.1rem;
    text-align: justify;
    min-height: 55vh;
    p {
      color: #13322b;
    }
    .explore {
      font-size: 1.5rem;
    }
  }
}
// Small devices
@media (max-width: 767px) {
  #Intro {
    .header {
      background-image: url("/assets/Header_MemorialDisperso.png");
    }
    .title-logo {
      max-height: 14vh;
      height: auto;
      max-width: 100%;
      object-fit: contain;
    }
    .introduction {
      font-size: 0.8rem;
      .explore {
        font-size: 1.2rem;
      }
    }
  }
}
</style>
